import * as Yup from "yup";
// define your fields
export const initialValues = {mobile: ""};
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

// define validation rules
export const validationSchema = Yup.object({
    mobile: Yup.string().required("موبایل را وارد کنید").min(10, "موبایل باید حداقل شامل 3 کاراکتر باشد").max(11, "موبایل باید حداقل شامل 11 کاراکتر باشد").matches(phoneRegExp, 'شماره موبایل نا معتبر'),
})